// import common_de from "./translations/de/common.json";
import i18next from "i18next";
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import {
  DEFAULT_LANGUAGE,
  DEFAULT_NAMESPACE,
  NAMESPACES,
} from "./i18nConstants";
export default function configTranslation() {
  i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next) 
    .init({
      fallbackLng: DEFAULT_LANGUAGE,
      appendNamespaceToCIMode: true,
      saveMissing: false,
      ns: Object.values(NAMESPACES),
      defaultNS: DEFAULT_NAMESPACE,
      debug: false,
      load: "languageOnly",
      keySeparator: ".",
      nsSeparator: ":", 
      interpolation: {
        escapeValue: false,
        formatSeparator: ",",
        format(value, format) {
          return format === "uppercase" ? value.toUpperCase() : value;
        },
      },
      react: {
        wait: true,
      },
    });
  return i18next;
}
